import React, { useState, useEffect, useReducer } from "react";
import {
  List,
  Icon,
  Form,
  Progress,
  Message,
  Accordion,
  Button,
} from "semantic-ui-react";
import { server } from "../../../App";
import axios from "axios";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import moment from "moment";
import Viewer from "react-viewer";
// import { toast } from "react-toastify";
import { selectisAuthenticated } from "../../../features/auth/authSlice";
import { UploadCounter } from "../../../features/counter/counterSlice";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { useSelector, useDispatch } from "react-redux";

const options = [
  { key: "1", text: "Retino", value: "1" },
  { key: "2", text: "Orthoptie", value: "2" },
  { key: "3", text: "Bilans", value: "3" },
  { key: "4", text: "Schéma", value: "4" },
  { key: "5", text: "LAF", value: "5" },
  { key: "6", text: "Angio", value: "6" },
  { key: "7", text: "OCT", value: "7" },
  { key: "8", text: "Topo", value: "8" },
  { key: "9", text: "M.Spécu", value: "9" },
  { key: "10", text: "Autres documents", value: "10" },
];

function FilesUpload(props) {
  const dispatchRedux = useDispatch();
  const AuthState = useSelector(selectisAuthenticated);
  const PatientelleState = useSelector(selectPatientelleGrid);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [SelectedCategorie, setSelectedCategorie] = useState(10);
  const [progress, setProgress] = useState();
  const [error, setError] = useState();
  const [activeIndex, setActiveIndex] = useState(20);
  const [visibleMessage] = useState(true);
  const [DocumentUpload, setDocumentUpload] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [visible4, setVisible4] = useState(false);
  const [visible5, setVisible5] = useState(false);
  const [visible6, setVisible6] = useState(false);
  const [visible7, setVisible7] = useState(false);
  const [visible8, setVisible8] = useState(false);
  const [visible9, setVisible9] = useState(false);
  const [visible10, setVisible10] = useState(false);

  async function getALLDocsOneUser() {
    await axios
      .get(`${server}UploadMedia/${PatientelleState.idpatient}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatchRedux(UploadCounter(response.data.length));
        setDocumentUpload(response.data);
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }
  useEffect(
    () => {
      getALLDocsOneUser();
    },
    // eslint-disable-next-line
    []
  );

  const submitHandler = async (e) => {
    e.preventDefault(); //prevent the form from submitting

    let formData = new FormData();
    for (const key of Object.keys(selectedFiles)) {
      formData.append("file", selectedFiles[key]);
    }
    setError("");
    await axios
      .post(
        `${server}UploadMedia/${PatientelleState.idpatient}/${SelectedCategorie}/${AuthState.user_name}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            jwtoken: sessionStorage.token,
          },
          onUploadProgress: (data) => {
            //Set the progress value to show the progress bar
            setProgress(Math.round((100 * data.loaded) / data.total));
          },
        }
      )
      .then((response) => {
        getALLDocsOneUser();
        dispatch({ type: ACTION.CREATE_ACT_SUCCESS });
      })
      .catch((error) => {
        const { code } = error?.response?.data;

        switch (code) {
          case "FILE_MISSING":
            setError("Please select a file before uploading!");
            break;
          case "LIMIT_FILE_SIZE":
            setError("File size is too large. Please upload files below 1MB!");
            break;
          case "INVALID_TYPE":
            setError(
              "This file type is not supported! Only .png, .jpg and .jpeg files are allowed"
            );
            break;

          default:
            setError(error?.response?.data);
            break;
        }
      });
  };
  const handleRemoveDoc = async (
    idUploadsPatients,
    fk_id_patient,
    reqOriginalFilesNames
  ) => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}UploadMedia/${idUploadsPatients}/${fk_id_patient}/${reqOriginalFilesNames}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        getALLDocsOneUser();
      })
      .then(() => dispatch({ type: ACTION.DELETE_SUCCESS }))
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  function name(params) {
    let uploadedFileName = params;

    let modName = uploadedFileName.slice(11, 30);

    return modName;
  }
  function FormatingADate(params) {
    let fix = moment(params).format("DD-MM-YYYY à HH:mm");
    return fix;
  }
  function VideoOrNot(params) {
    let str1 = params;
    let x = /mp4$/.test(str1);
    // return x
    let y = /(aac)$/.test(str1);
    let z = /(pdf)$/.test(str1);
    if (x) {
      return "video";
    } else if (y) {
      return "audio";
    } else if (z) {
      return "pdf";
    }
  }

  const handleDismiss = () => {
    dispatch({ type: ACTION.CREATE_ACT_SUCCESS_CLEAR });
  };
  let ImportantMessage;

  if (state.success && visibleMessage === true) {
    ImportantMessage = (
      <Message
        className="ImportantMessage"
        color="green"
        onDismiss={handleDismiss}
      >
        <Message.Header>Important!</Message.Header>
        {state.success}
      </Message>
    );
  }
  const handleDismissERROR = () => {
    setError(null);
  };
  let ImportantERRORMessage;

  if (error && visibleMessage === true) {
    ImportantERRORMessage = (
      <Message
        className="ImportantMessage"
        color="orange"
        onDismiss={handleDismissERROR}
      >
        <Message.Header>Warning!</Message.Header>
        {error}
      </Message>
    );
  }

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };
  function CategoryMAP(params) {
    let newArray = DocumentUpload.filter(function (el) {
      return el.fk_id_category === params; // Changed this so a home would match
    });
    return newArray;
  }
  let r1 = [];
  let r2 = [];
  let r3 = [];
  let r4 = [];
  let r5 = [];
  let r6 = [];
  let r7 = [];
  let r8 = [];
  let r9 = [];
  let r10 = [];

  let createNewArraysForImageviewing = (index, variable) => {
    CategoryMAP(index).map(
      (item, i) =>
        (variable = [
          ...variable,
          { src: item.url_doc, alt: item.idUploadsPatients },
        ])
    );
    return variable;
  };

  //   console.log(createNewArraysForImageviewing(1, r1));

  return (
    <div
      style={{
        // "width": "100vw",
        // "height": "32rem",
        height: "50vh",
        // "height": "42.2vh",
        // "width": "28vw !important",
        overflowY: "scroll",
        overflow: "auto",
      }}
    >
      <Form onSubmit={(e) => submitHandler(e)}>
        <Form.Group className="fixingUploadForm">
          <Form.Input
            // compact
            type="file"
            className="fixingUploadInput"
            onChange={(e) => {
              setSelectedFiles(e.target.files);
            }}
            multiple
          />
          <Form.Select
            value={SelectedCategorie}
            fluid
            options={options}
            placeholder="Catégorie"
            className="fixingUploadselect"
            onChange={(e, data) => {
              setSelectedCategorie(data.value);
            }}
          />

          <Button className="fixingUploadBtn">OK</Button>
        </Form.Group>

        {ImportantMessage}

        {ImportantERRORMessage}
        {progress < 100 && progress > 0 ? (
          <Progress
            className="progressBarwidth"
            percent={progress}
            success
            progress
            active
          />
        ) : null}
      </Form>

      <Accordion styled className="accordion">
        <Accordion.Title
          className={CategoryMAP(1).length > 0 ? "titredUPLOAD" : ""}
          active={activeIndex === 0}
          index={0}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Rétinographie{" "}
          {CategoryMAP(1).length > 0 ? (
            <span className="notification">( {CategoryMAP(1).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 0}>
          {CategoryMAP(1).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                      }}
                      images={createNewArraysForImageviewing(1, r1)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>

        <Accordion.Title
          className={CategoryMAP(2).length > 0 ? "titredUPLOAD2" : ""}
          active={activeIndex === 1}
          index={1}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Orthoptie{" "}
          {CategoryMAP(2).length > 0 ? (
            <span className="notification">( {CategoryMAP(2).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 1}>
          {CategoryMAP(2).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible2(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible2}
                      onClose={() => {
                        setVisible2(false);
                      }}
                      images={createNewArraysForImageviewing(2, r2)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>

        <Accordion.Title
          className={CategoryMAP(3).length > 0 ? "titredUPLOAD3" : ""}
          active={activeIndex === 2}
          index={2}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Bilans{" "}
          {CategoryMAP(3).length > 0 ? (
            <span className="notification">( {CategoryMAP(3).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 2}>
          {CategoryMAP(3).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible3(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible3}
                      onClose={() => {
                        setVisible3(false);
                      }}
                      images={createNewArraysForImageviewing(3, r3)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(4).length > 0 ? "titredUPLOAD4" : ""}
          active={activeIndex === 3}
          index={3}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Schéma{" "}
          {CategoryMAP(4).length > 0 ? (
            <span className="notification">( {CategoryMAP(4).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 3}>
          {CategoryMAP(4).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible4(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible4}
                      onClose={() => {
                        setVisible4(false);
                      }}
                      images={createNewArraysForImageviewing(4, r4)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(5).length > 0 ? "titredUPLOAD5" : ""}
          active={activeIndex === 4}
          index={4}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          LAF{" "}
          {CategoryMAP(5).length > 0 ? (
            <span className="notification">( {CategoryMAP(5).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 4}>
          {CategoryMAP(5).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible5(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible5}
                      onClose={() => {
                        setVisible5(false);
                      }}
                      images={createNewArraysForImageviewing(5, r5)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(6).length > 0 ? "titredUPLOAD6" : ""}
          active={activeIndex === 5}
          index={5}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Angiographie{" "}
          {CategoryMAP(6).length > 0 ? (
            <span className="notification">( {CategoryMAP(6).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 5}>
          {CategoryMAP(6).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible6(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible6}
                      onClose={() => {
                        setVisible6(false);
                      }}
                      images={createNewArraysForImageviewing(6, r6)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(7).length > 0 ? "titredUPLOAD7" : ""}
          active={activeIndex === 6}
          index={6}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          OCT{" "}
          {CategoryMAP(7).length > 0 ? (
            <span className="notification">( {CategoryMAP(7).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 6}>
          {CategoryMAP(7).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible7(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible7}
                      onClose={() => {
                        setVisible7(false);
                      }}
                      images={createNewArraysForImageviewing(7, r7)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(8).length > 0 ? "titredUPLOAD8" : ""}
          active={activeIndex === 7}
          index={7}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Topographie cornéenne{" "}
          {CategoryMAP(8).length > 0 ? (
            <span className="notification">( {CategoryMAP(8).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 7}>
          {CategoryMAP(8).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible8(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible8}
                      onClose={() => {
                        setVisible8(false);
                      }}
                      images={createNewArraysForImageviewing(8, r8)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>

        <Accordion.Title
          className={CategoryMAP(9).length > 0 ? "titredUPLOAD9" : ""}
          active={activeIndex === 8}
          index={8}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Microscopie spéculaire{" "}
          {CategoryMAP(9).length > 0 ? (
            <span className="notification">( {CategoryMAP(9).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 8}>
          {CategoryMAP(9).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible9(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible9}
                      onClose={() => {
                        setVisible9(false);
                      }}
                      images={createNewArraysForImageviewing(9, r9)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
        <Accordion.Title
          className={CategoryMAP(10).length > 0 ? "titredUPLOAD10" : ""}
          active={activeIndex === 9}
          index={9}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          Autres documents{" "}
          {CategoryMAP(10).length > 0 ? (
            <span className="notification">( {CategoryMAP(10).length} )</span>
          ) : (
            "( 0 )"
          )}
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 9}>
          {CategoryMAP(10).map((item, i) => (
            <List key={item.idUploadsPatients}>
              <List.Item style={{ display: "flex" }}>
                {VideoOrNot(item.reqOriginalFilesNames) === "video" ? (
                  <video
                    width="200"
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="video/mp4" />
                    <source src={item.url_doc} type="video/ogg" />
                    Your browser does not support HTML video.
                  </video>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "audio" ? (
                  <audio
                    controls
                    disablePictureInPicture
                    controlslist="nodownload noremoteplayback noplaybackrate"
                    style={{ marginRight: "0.5rem" }}
                  >
                    <source src={item.url_doc} type="audio/aac" />
                    Your browser does not support HTML video.
                  </audio>
                ) : VideoOrNot(item.reqOriginalFilesNames) === "pdf" ? (
                  <a
                    href={item.url_doc}
                    download={item.reqOriginalFilesNames}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://aniba.ddns.net/UploadMedia/file/pdf.png"
                      alt={name(item.reqOriginalFilesNames)}
                      width="150"
                      style={{ marginRight: "0.5rem" }}
                    />
                  </a>
                ) : (
                  // <a href={item.url_doc} download="w3logo" target="_blank" rel="noopener noreferrer">
                  //     <img src={item.url_doc} alt={name(item.reqOriginalFilesNames)} width="150" style={{ "marginRight": "0.5rem" }} />
                  // </a>}
                  <>
                    <img
                      onClick={() => {
                        setVisible10(true);
                      }}
                      src={item.url_doc}
                      alt={name(item.reqOriginalFilesNames)}
                      width="200"
                      style={{ marginRight: "0.5rem" }}
                    />

                    <Viewer
                      visible={visible10}
                      onClose={() => {
                        setVisible10(false);
                      }}
                      images={createNewArraysForImageviewing(10, r10)}
                    />
                  </>
                )}

                <List.Content>
                  <List.Header as="a">
                    {name(item.reqOriginalFilesNames)}
                  </List.Header>
                  <List.Description>
                    Uploaded par{" "}
                    <b>
                      <b>{item.uploaded_by}</b>
                    </b>{" "}
                    <br />
                    Le {FormatingADate(item.created_At)}{" "}
                    <span className="hoverEffect">
                      <Icon
                        onClick={() =>
                          handleRemoveDoc(
                            item.idUploadsPatients,
                            item.fk_id_patient,
                            item.reqOriginalFilesNames
                          )
                        }
                        circular
                        name="delete"
                        inverted
                        color="red"
                      />
                    </span>{" "}
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          ))}
        </Accordion.Content>
      </Accordion>
    </div>
  );
}

export default FilesUpload;
